export class Timekeeper {
    static instance;
    static getInstance() {
        if (!Timekeeper.instance) {
            Timekeeper.instance = new Timekeeper();
        }
        return Timekeeper.instance;
    }
    // ------------- Singleton implementation end
    lastTimestampMicros = 0n;
    constructor() { }
    setLastTimestampMicros(timestampMicros) {
        this.lastTimestampMicros = timestampMicros;
    }
    getLastTimestampMicros() {
        return this.lastTimestampMicros;
    }
}
